import http from '@/assets/common/http';
// ------------------------------------------手动录入
export function addOrderFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------一键转换
export function oneGYSFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 17,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 一键转换采购
export function transferSellFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 50,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------------获取客户
export function haveGYSFun () {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 9,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
export function getEnteyCusFun () {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 16,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// --------------------------------------------手动录入->订单增加产品功能
export function addProductFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------查询客户数据(供应商录入订单数据)
export function chooseTCFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------客户数据---------------------------------------------修改
export function selectTCFun (data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------项目点数据
export function selectProjectFun (data) {
  const params = {
    SERVICE_ID: '10006',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------------档口数据
export function selectDKFun (data) {
  const params = {
    SERVICE_ID: '10007',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------------修改订单详情产品数量
export function updateOrderFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 30,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------------删除订单详情产品
export function deleteOrderDetailFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 5,
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------------删除订单
export function deleteOrderFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------------录入完成功能
export function finishEntryFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------------SKU库
export function chooseEntryFun (data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 19,
    // OTYPE: 10,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------查看订单详情
export function orderDetailFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 4,
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------导出订单
export function printOrderFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 10,
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------------------------------------------------待送订单
export function newOrderFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------修改待送订单详情页面数据(无限制)
export function updateNewDetailFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 9,
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------修改待送订单详情页面数据(有限制)
export function updateNewDetailFun_Limit (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 48,
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------------获取供应商以及项目点
export function haveXMDFun () {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// --------------------------------------------------获取待送项目点
export function haveDSXMDFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 15,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------设置时是否为补单
export function setOrderFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 13,
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------复制订单
export function copyOrderFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------------查看未处理订单详情
export function notOrderDetailFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------------查看未处理订单详情
export function notOrderDetailCus (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 29,
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------------更新订单至已打印状态
export function updatePrintOrderFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 4,
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------------供应商对供应商更新订单至待确认
export function updateSupplierPrintOrderFun (data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 39,
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------------导出当前订单
export function exportOrderFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 5,
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------------导出根据日期搜索的全部团餐客户待送订单
export function exportTotalOrderFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 14,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------------订单资质管理
export function orderContractFun (data) {
  const params = {
    SERVICE_ID: '10027',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------------添加订单资质
export function addOrderContractFun (data) {
  const params = {
    SERVICE_ID: '10027',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------------删除订单资质
export function deleteOrderContractFun (data) {
  const params = {
    SERVICE_ID: '10027',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------------------待项目点确认
export function orderConfirmFun (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------------------自录订单确认
export function orderConfireSupplierFun (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------------------获取确认订单详情功能
export function orderConfirmDetailFun (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------------------确定订单
export function confirmOrderFun (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------------------待确定订单--自录订单修改
export function updateZLFun (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------------------导出待确定订单
export function exportConfirmFun (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 6,
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------------------------导出带项目点确认订单
export function exportAll (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 10,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------历史订单
// ---------------------------------------进入页面拉取数据接口
export function historyDataFun (data) {
  const params = {
    SERVICE_ID: '10012',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------查询历史订单详情
export function historyDetailDataFun (data) {
  const params = {
    SERVICE_ID: '10012',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------导出订单
export function outHistoryFun (data) {
  const params = {
    SERVICE_ID: '10012',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------导出全部订单
export function outHistoryAllFun (data) {
  const params = {
    SERVICE_ID: '10012',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------导入历史单据
export function importHistoryDocuments (data) {
  const params = {
    SERVICE_ID: '10012',
    OTYPE: 10,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------修改自录订单状态
export function updateStatusFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 12,
    ...data,
  };
  return http.post(params);
}
// 批量发起
export function bulkLaunch (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 15,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出检验报告
export function exportCheckFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 18,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改订单日期
export function editDate (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 38,
    // GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 更新送货数量
export function updatesendCountFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 19,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 更新为送货数量
export function updateSendFun (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 11,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 更新为订购数量
export function updateBookFun (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 12,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 打印标签
export function queryPrint (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 16,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导入销售订单
export function exportSellOrder (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 17,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 订单退货
export function orderReturnFun (data) {
  const params = {
    SERVICE_ID: '10012',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 计算价格
export function priceCountFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 30,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 自有分类导出订单
export function outSelfKindOrder (data) {
  const params = {
    SERVICE_ID: '10012',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出全部待确认订单
export function exportConfirmOrderFun (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 13,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 全部订单拉取
export function allOrderDataFun (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 14,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出全部订单
export function allOrderExportFun (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 15,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导入订单
export function exportPriceOrder (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 31,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出PDF
export function exportPdfOrder (data) {
  const params = {
    SERVICE_ID: '10042',
    OTYPE: 21,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 销售订单打印次数记录
export function updatePrintTimeFun (data) {
  const params = {
    SERVICE_ID: '10004',
    OTYPE: 12,
    ...data,
  };
  return http.post(params);
}
// 补出库
export function addOutFun (data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 75,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
export function _conversionConfirmed (data) {
  const params = {
    SERVICE_ID: '10042',
    OTYPE: 23,
    ...data,
  };
  return http.post(params);
}
// 拉取供应商客户待送订单
export function supplierCusNewOrder (data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 7,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 供应商客户订单详情
export function supplierCusNewDetailFun (data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 4,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取供应商客户待确认订单
export function supplierCusConfirmOrder (data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 38,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 打印改变供应商客户待送订单状态
export function updateSupplierCusOrderFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 4,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取供应商客户历史订单
export function supplierCusHisDetailFun (data) {
  const params = {
    SERVICE_ID: '10034',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取供应商客户历史订单
export function supplierCusHistoryFun (data) {
  const params = {
    SERVICE_ID: '10034',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 下载减单
export function doDownloadFun (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 单个订单导出PDF
export function orderPrintFunc (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 单个订单转已打印
export function toPrintedFun (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 批量导出PDF
export function batchExportFun (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 60,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取某个客户下全部项目
export function getTCProjectFun (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 历史订单修改
export function modifyOrderFun (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询价格审核
export function queryPriceAudit (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除sku
export function deletedSku (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 10,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询价格审核
export function queryPurchaseAudit (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改
export function editSku (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 13,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 价格审核
export function querySkuAudit (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 12,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 订单查询
export function searchSellFun (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 14,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 订单查询导出
export function exportSellFun (data) {
  const params = {
    SERVICE_ID: '10174',
    OTYPE: 15,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导入财务做账订单
export function exportFinanceOrderFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 14,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 批量转换第三方配送订单
export function transferOrderFunc (data) {
  const params = {
    SERVICE_ID: '10179',
    OTYPE: 3,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
    ...data,
  };
  return http.post(params);
}
// 拉取全部学校
export function selectAllCusFun (data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 批量修改送货数量
export function batchEdit (data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 53,
    ...data,
  };
  return http.post(params);
}
// 第三方配送订单-导出PDF
export function thirdPartyExportPDFFun (data) {
  const params = {
    SERVICE_ID: '10179',
    OTYPE: 5,
    ...data,
  };
  return http.post(params);
}
// 销售单下载批次报告
export function downloadOrderBatchReportFun (data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 20,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取和供应链建立了供应关系的项目(待送、待确认、历史)
export function getHaveSupplyRelationshipProjectList (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 88,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}

export function 获取订单产品毛利表数据 (data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 99,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/sellOrder.js